<template>
    <Loading>
        <div class="p-4">
            <div class="grid">
                <Row class="text-row" />
                <Row class="text-row" />

                <Divider style="grid-column:span 3;" />
                <Row class="input-row" rounded />
                <Row class="input-row" rounded />
                <Row class="input-row" rounded />

                <Divider style="grid-column:span 3;" />
                <Row class="input-row" rounded />
                <Row class="input-row" rounded />
                <Row class="input-row" rounded />
            </div>
            <Row class="input-row mt-4" rounded />
        </div>
    </Loading>
</template>

<script>
import Loading from '~/components/skeletons/base/Loading';
import Avatar from '~/components/skeletons/base/Avatar';
import Row from '~/components/skeletons/base/Row';

export default {
    name: 'LanguagesSkeleton',
    components: { Loading, Avatar, Row },
};
</script>

<style scoped>
.grid {
    display: grid;
    grid-template-columns: auto auto 20px;
    grid-gap: 10px;
}

.input-row {
    height: 38px;
    margin-bottom: 0px !important;
}

.text-row {
    width: 120px;
}

@media only screen and (max-width: 600px) {
    .text-row {
        width: 75px;
    }
}
</style>
